import { classnames } from 'helpers/utils';
import styles from './labeled-text.module.scss';

type LabeledTextProps = {
  label: string;
  text: string;
  vertical?: boolean;
  className?: string;
  labelClassName?: string;
  textClassName?: string;
};

const LabeledText = ({
  label,
  text,
  vertical = false,
  className = '',
  labelClassName = '',
  textClassName = '',
}: LabeledTextProps) => (
  <div
    className={classnames(className, styles.labeledText, {
      [styles.vertical]: vertical,
    })}
  >
    <span
      className={classnames(
        'text__body__semi__bold__medium__gray800',
        labelClassName,
      )}
    >
      {label}:
    </span>
    <span
      className={classnames(
        'text__body__regular__small__gray700',
        textClassName,
      )}
    >
      {text}
    </span>
  </div>
);

export { LabeledText };
